export default __webpack_public_path__ + "static/banner-consolidating-debt-what-you-need-to-know-0d0fdafe96c535b5f076ba044d36cb24.jpg";